import { configureStore } from '@reduxjs/toolkit';
import userReducer from './slices/userSlice';
import commonReducer from './slices/commonSlice';
import searchBarReducer from './slices/searchBarSlice';

export const store = configureStore({
  reducer: {
    user: userReducer,
    common: commonReducer,
    searchBar: searchBarReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; 


